import React from "react";
import cIf from 'classnames';
import './buttonslist.scss';

export interface ButtonInfo {
    class?: string,
    children: any,
    buttonWidth?: string,
    disabled?: boolean,
    onClick: (e: any) => void
}

interface ButtonsListProps {
    numberOfColumns?: number,
    buttonInfos: Array<ButtonInfo>
}

export function ButtonsList({buttonInfos, numberOfColumns}: ButtonsListProps) {
    let keyUniq = 0;


    const colSplit =  12 / (numberOfColumns ? numberOfColumns : 1);

    const buttons = buttonInfos.map((buttonInfo) => {
        keyUniq++;
        const buttonWidth = (buttonInfo.buttonWidth) ? buttonInfo.buttonWidth : "100%";
        const disabled = (buttonInfo.disabled) ? buttonInfo.disabled : false;
        
        return <div key={keyUniq} className={"col-md-" + colSplit}>
            <button  type="button" className={cIf([{ btn: true }, buttonInfo.class])} style={{width: buttonWidth}} disabled={disabled} onClick={buttonInfo.onClick}>{buttonInfo.children}</button>
        </div>;
    });

    return <div className="ButtonsList">
        <div className="row">
            {buttons}
        </div>
    </div>;
}